import styled from "styled-components";
import {
	DESKTOP_SM_BP,
	MOBILE_L_BP,
	FONT_WT_LIGHT,
	FONT_WT_MEDIUM,
	COLOR_TEXT_PRIMARY_B2C,
	COLOR_WHITE,
} from "@website-builder/utilities-index";

export const StudentsWrapper = styled.div`
	padding: 100px 10px;
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		padding: 50px 10px;
	}
`;

export const CardsWrapper = styled.div`
	display: flex;
	flex-flow: wrap;
	justify-content: center;
	a {
		text-decoration: none;
		text-align: center;
	}
`;

export const Heading = styled.div`
	text-align: center;
	font-size: 28px;
	font-weight: ${FONT_WT_MEDIUM};
	color: ${COLOR_TEXT_PRIMARY_B2C};
	margin-bottom: 50px;
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		margin-bottom: 33px;
	}
`;

export const Container = styled.div`
	margin: 0 6px 20px;
	display: flex;
	flex-direction: column;
	width: 240px;
	align-items: center;
	padding: 20px;
	border-radius: 3px;
	box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.1);
	background-color: ${COLOR_WHITE};
	&:hover {
		transition: 0.3s;
		transform: translate(0, -5px);
	}
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		width: 166px;
		padding: 14px;
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		margin-left: 2px;
		margin-right: 2px;
	}
`;

export const SubHeading = styled.div`
	margin-top: 20px;
	height: 35px;
	font-size: 16px;
	text-align: center;
	font-weight: ${FONT_WT_LIGHT};
	font-style: italic;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		margin-top: 0px;
		height: auto;
	}
`;

export const Image = styled.div`
	height: 121px;
	img {
		height: 100%;
	}
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		height: 82px;
	}
`;

export const Title = styled.div`
	font-size: 18px;
	font-weight: ${FONT_WT_MEDIUM};
	line-height: 1.69;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	margin-top: 15px;
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		margin-top: 10px;
	}
`;

export const SubTitile = styled.div`
	font-size: 16px;
	font-weight: ${FONT_WT_LIGHT};
	line-height: 1.43;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	margin-top: 2px;
`;
